import { useState, useEffect, useRef } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import MDAvatar from "components/MDAvatar";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
 import { alpha, CircularProgress, Switch, ThemeProvider } from "@mui/material";
// import { capitalizeFirstLetter } from "examples/CommonFunctions";
// @mui material components
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Add } from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";
// import { createApiAction } from "store/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import profileDefault from "assets/images/Profile-default.jpg";
import { IconButton } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
//dialog
import {
  TextField,
} from "@mui/material";

import Pagination from "@mui/material/Pagination";
import { formatDate } from "utils/formatData";
import { baseUrl } from "services/axiosInstance";
import { getReportedUsers, updateUserStatus } from "../../redux/slices/reportedUserSlice";
import { capitalizeFirstLetter } from "utils/formatData";
import { pink } from "@mui/material/colors";
import theme from "assets/theme";
import { switchTheme } from "examples/CommonFunctions";
import { updateReportStatus } from "services/apis";

function ReportedUsers({ pageName = "reportTable" }) {
  const navigate = useNavigate();
  const [menu, setMenu] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const dispatch = useDispatch();
  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);
  // const userData = useSelector((state) => state.apiData.data.data)
  const { repostedData: userData } = useSelector((state) => state.reportedUsers);
  //   const { totalCount } = useSelector((state) => state.userData.userData);
  const totalCount = 2;
  const { error } = useSelector((state) => state.userData);
  const [page, setPage] = useState(1);
  const [searchPage, setSearchPage] = useState(1);
  const itemsPerPage = 10;
  const timeoutRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [initalLoading, setInitialLoading] = useState(false); //true default

  const handleReportdNavigate = () => {
    if (pageName === "dashboard") {
      navigate("/reportedUsers");
    }
  };
  const handleToggle = async (id, status) => {
    try {
      const response = await updateReportStatus(id, { status: !status });
      if (response?.success) {
        dispatch(updateUserStatus({ id, status: !status }));
      }
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setSearchText(value);
    }, 300);
  };

  const [loading, setLoading] = useState(true);


  const [rows, setRows] = useState([]);



  const handleNavigate = (userId) => {
    navigate(`/userProfile/${userId}`);
  };

  const avatars = (members) =>
    members.map(([image, name]) => (
      <Tooltip key={name} title={name} placeholder="bottom">
        <MDAvatar
          src={image}
          alt="name"
          sx={{
            border: ({ borders: { borderWidth }, palette: { white } }) =>
              `${borderWidth[2]} solid ${white.main}`,
            cursor: "pointer",
            position: "relative",

            "&:not(:first-of-type)": {
              ml: -1.25,
            },

            "&:hover, &:focus": {
              zIndex: "10",
            },
          }}
        />
      </Tooltip>
    ));



  const handleRows = () => {
    if (userData?.length > 0) {
      const rowsAPI = (pageName === "dashboard"
        ? userData.slice(0, 3)
        : userData
      ).map((user) => ({
        Reported: (
          <MDBox display="flex" py={1}
            onClick={() => handleNavigate(user.reportingUser)}
          >
            {avatars([[user?.reporter?.userProfiles?.[0]?.image, user?.reporter?.name]])}
          </MDBox>
        ),
        Reporter: (
          <MDBox display="flex" py={1}
            onClick={() => handleNavigate(user.reportedUser)}
          >
            {avatars([[user?.reported?.userProfiles?.[0]?.image, user?.reported?.name]])}
          </MDBox>
        ),
        reason: (
          <MDBox
            sx={{
              overflow: "hidden",
              width: "350px",
              minHeight: "10px",
              maxHeight: "90px",
            }}
          >
            <MDTypography
              variant="caption"
              color="text"
              fontWeight="medium"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
              }}
            >
              {user?.reason}
            </MDTypography>
          </MDBox>
        ),
        date: formatDate(user.createdAt),
        description: (
          <MDBox
            sx={{
              overflow: "hidden",
              width: "420px",
              minHeight: "10px",
              maxHeight: "90px",
            }}
          >
            <MDTypography
              variant="caption"
              color="text"
              fontWeight="medium"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
              }}
            >
              {user?.description || "NA"}
            </MDTypography>
          </MDBox>
        ),

        status: (

          <MDBox>
            <ThemeProvider theme={switchTheme}>
              <MDBox>
                <Switch checked={user?.status === true} onChange={() => handleToggle(user.id, user.status)} />
              </MDBox>
            </ThemeProvider>
          </MDBox>
        ),
      }));

      setRows(rowsAPI);
      setLoading(true);
    } else {
      setRows([]);
      setLoading(true);
    }
  };

  const handleuserApiCall = async () => {
    try {
      dispatch(getReportedUsers());

    } catch (e) {
      console.log("e: ", e);
    }
    // if (searchText.trim() !== "") {
    //   try {
    //     const SearchData = {
    //       search_keyword: searchText,
    //     };
    //     await dispatch(
    //       createApiAction(
    //         `/api/dev/admin/user/usersSearch?page=${searchPage}&limit=${itemsPerPage}`,
    //         "POST",
    //         SearchData
    //       )
    //     ).then(() => {setLoading(false);
    //       setInitialLoading(false)
    //     });
    //   } catch (error) {
    //     console.log("Error fetching data:", error);
    //       setInitialLoading(false)
    //   }
    // } else if (searchText.trim() === "") {
    //   try {
    //     await dispatch(
    //       createApiAction(
    //         `/api/dev/admin/user/getAllusers?page=${page}&limit=${itemsPerPage}`,
    //         "GET"
    //       )
    //     ).then(() => {
    //       setLoading(false);
    //       setInitialLoading(false)
    //       setSearchPage(1);
    //     });
    //   } catch (error) {
    //     console.log("Error fetching data:", error);
    //     setInitialLoading(false)
    //   }
    // }
  };

  const allColumns = [
    { Header: "Reported", accessor: "Reported", width: "10%", align: "center", disableSortBy: true },
    { Header: "Reporter", accessor: "Reporter", width: "10%", align: "center", disableSortBy: true },
    { Header: "reason", accessor: "reason", align: "center", disableSortBy: true },
    {
      Header: "Reported On",
      accessor: "date",
      align: "center",
      sortType: (rowA, rowB) => {
        const dateA = new Date(rowA.original.date);
        const dateB = new Date(rowB.original.date);
        return dateA - dateB;
      },
    },
    { Header: "description", accessor: "description", align: "center", disableSortBy: true },
    { Header: "Resolved Status", accessor: "status", align: "center", disableSortBy: true },
  ];

  const columns = pageName === "dashboard"
    ? allColumns.filter(col => col.accessor !== "description")
    : allColumns;

  useEffect(() => {
    handleRows()
  }, [userData])

  useEffect(() => {
    handleuserApiCall();
  }, []);

  //   useEffect(() => {
  //     if (!loading) {
  //       handleRows();
  //     }
  //   }, [loading, userData, page, searchPage]);

  //   useEffect(() => {
  //     handleuserApiCall();
  //   }, [searchText, page, searchPage]);

  return (
    <Card>
      {!initalLoading ? (
        <MDBox  >
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="light"
            borderRadius="lg"
            coloredShadow="light"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              p: 3,
            }}
          >
            <MDBox
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                mb: { xs: 2, sm: 0 },
              }}
            >
              <MDTypography variant="h5" color="white"
                onClick={handleReportdNavigate}
                style={pageName === "dashboard" ? { cursor: "pointer" } : {}}
              >
                {`Reported Users`}
              </MDTypography>
            </MDBox>

            <MDBox
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                gap: { xs: 2, sm: 0 },
                justifyContent: { xs: "center", sm: "flex-end" },
              }}
            >
              {/* <MDBox
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: { xs: "100%", sm: "auto" },
                          mb: { xs: 2, sm: 0 },
                        }}
                      >
                        <TextField
                          onChange={handleSearchChange}
                          id="standard-bare"
                          variant="outlined"
                          placeholder="Search user"
                          sx={{
                            "& .MuiInputBase-input": {
                              color: "#ffffff",
                              width: { xs: "100%", sm: "240px" },
                            },
                          }}
                          InputProps={{
                            endAdornment: (
                              <IconButton>
                                <SearchOutlined color="white" />
                              </IconButton>
                            ),
                          }}
                        />
                      </MDBox> */}
            </MDBox>
          </MDBox>

          <MDBox
            pt={3}
            sx={pageName === "dashboard" ? { maxHeight: 400, overflow: "auto" } : {}}
          >
            {rows?.length > 0 ? (
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
              />
            ) : (
              <MDBox sx={{ display: "flex", padding: "20px", justifyContent: "center" }}>
                <MDTypography variant="caption" sx={{ fontSize: "20px" }}>
                  {/* { !loading &&" No Users are present at this time." }  */}
                </MDTypography>
              </MDBox>
            )}
          </MDBox>
          {pageName !== "dashboard" &&

            <MDBox display="flex" justifyContent="center" alignItems="center" mt={2} mb={3}>
              <Pagination
                count={Math.ceil(totalCount / itemsPerPage)}
                page={searchText === "" ? page : searchPage}
                onChange={(event, value) => {
                  {
                    searchText === "" ? setPage(value) : setSearchPage(value);
                  }
                }}
                color="light"
                shape="rounded"
                size="large"
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&:hover": {
                      backgroundColor: "#FC8954",
                    },
                  },
                  "& .MuiPaginationItem-previousNext": {
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                  },
                }}
              />
            </MDBox>
          }
        </MDBox>
      ) : !error ? (
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100vw"
          height="100vh"
          position="fixed"
          top={0}
          left={0}
        >
          <CircularProgress sx={{ color: "orange" }} size={54} />
        </MDBox>
      ) : (
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100vw"
          height="100vh"
          position="fixed"
          top={0}
          left={0}
        >
          <MDTypography>Error Occured</MDTypography>
        </MDBox>
      )}
    </Card>
  );
}

export default ReportedUsers;
